// components/OpenLayersMap.jsx
import React, { useEffect, useRef } from 'react';
import 'ol/ol.css';
import { Map, View } from 'ol';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import { OSM } from 'ol/source';
import { Vector as VectorSource } from 'ol/source';
import { Point, LineString } from 'ol/geom';
import { Feature } from 'ol';
import { fromLonLat } from 'ol/proj';
import { Style, Stroke, Circle as CircleStyle, Fill } from 'ol/style';

const OpenLayersMap = ({ puntos = [] }) => {
  const mapRef = useRef();

  useEffect(() => {
    const transform = ([lat, lng]) => fromLonLat([lng, lat]);

    // Crear marcadores
    const features = puntos.map((p) => {
      const marker = new Feature({
        geometry: new Point(transform([p.lat, p.lng])),
        nombre: p.nombre,
      });

      marker.setStyle(
        new Style({
          image: new CircleStyle({
            radius: 6,
            fill: new Fill({ color: '#1D4ED8' }),
            stroke: new Stroke({ color: '#ffffff', width: 2 }),
          }),
        })
      );

      return marker;
    });

    // Crear línea entre puntos
    const lineaRuta = new Feature({
      geometry: new LineString(puntos.map((p) => transform([p.lat, p.lng]))),
    });

    lineaRuta.setStyle(
      new Style({
        stroke: new Stroke({
          color: '#2563EB',
          width: 3,
        }),
      })
    );

    const vectorLayer = new VectorLayer({
      source: new VectorSource({
        features: [...features, lineaRuta],
      }),
    });

    const map = new Map({
      target: mapRef.current,
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
        vectorLayer,
      ],
      view: new View({
        center: fromLonLat([-70.6693, -33.4489]),
        zoom: 13,
      }),
    });

    return () => {
      map.setTarget(null);
    };
  }, [puntos]);

  return <div ref={mapRef} className="w-full h-[500px] rounded shadow" />;
};

export default OpenLayersMap;